import React from 'react';
import { Spin, Button } from 'antd';
import { Icon } from '@iconify/react';
import { useModel } from '@umijs/max';
import Upload from '@/components/Upload';

const Index: React.FC = () => {
  const [loading, setLoading] = React.useState(false);
  const { lastDir, fileType, refresh } = useModel('fileModel');

  return (
    <>
      <Upload
        onSuccess={() => {
          setLoading(false);
          refresh();
        }}
        dir={lastDir}
        isResource={true}
        multiple={true}
        fileType={fileType}
        beforeUpload={() => {
          setLoading(true);
          return true;
        }}
      >
        <Button type={'primary'}>
          <Icon icon={'material-symbols:upload'}></Icon>
        </Button>
      </Upload>
      <Spin tip="Uploading..." spinning={loading} size="large" fullscreen />
    </>
  );
};

export default Index;
